export default "__VITE_ASSET__MP1_Hnuh__"